import React from 'react';
import { GenericFormPage } from '../../components/generic';
import { CustomField, useCustomField, createCustomField, updateCustomField } from './useData';
import { useParams } from 'react-router-dom';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const isEdit = !!id;

  const useCustomFieldData = (fieldId: number) => {
    const { data, isLoading, mutate } = useCustomField(fieldId);
    return {
      data,
      client: data, // GenericFormPage expects either data or client
      isLoading,
      mutate,
    };
  };

  return (
    <GenericFormPage<CustomField>
      useData={useCustomFieldData}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
